import { useMemo } from "react";
import useSWR from "swr";
import { cn } from "@/lib/utils";

/**
 * 展示 Selection 绑定的大类（layer-group）名称，对齐普通模版 Layers 表的 Group 列。
 */
export function SelectionGroupLabel({
  gid,
  className,
}: {
  gid?: string;
  className?: string;
}) {
  const { data: layerGroups = [] } = useSWR(["/layer-groups"]);

  const groupName = useMemo(() => {
    if (!gid) return "";
    const group = (layerGroups as any[]).find(
      (g: any) => g.id === gid && g.state !== -1,
    );
    return group?.name || "";
  }, [gid, layerGroups]);

  if (!gid) {
    return (
      <span
        className={cn(
          "shrink-0 max-w-[100px] truncate text-xs text-muted-foreground",
          className,
        )}
        title="未设置大类"
      >
        —
      </span>
    );
  }

  const label = groupName || gid;

  return (
    <span
      className={cn(
        "shrink-0 max-w-[100px] truncate rounded bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground",
        className,
      )}
      title={`${label}${groupName ? ` (${gid})` : ""}`}
    >
      {label}
    </span>
  );
}
